export const SCOPE = 'persistence';

export const GET_URL_PERSISTENT_CONFIGURATION = `${SCOPE}/GET_URL_PERSISTENT_CONFIGURATION`;
export const GET_URL_PERSISTENT_CONFIGURATION_SUCCESS = `${SCOPE}/GET_URL_PERSISTENT_CONFIGURATION_SUCCESS`;
export const GET_URL_PERSISTENT_CONFIGURATION_FAIL = `${SCOPE}/GET_URL_PERSISTENT_CONFIGURATION_FAIL`;
export const DELETE_URL_PERSISTENT_CONFIGURATION = `${SCOPE}/DELETE_URL_PERSISTENT_CONFIGURATION`;

export const UPDATE_URL_PERSISTENT_CONFIGURATION = `${SCOPE}/UPDATE_URL_PERSISTENT_CONFIGURATION`;
export const UPDATE_URL_PERSISTENT_CONFIGURATION_SUCCESS = `${SCOPE}/UPDATE_URL_PERSISTENT_CONFIGURATION_SUCCESS`;
export const UPDATE_URL_PERSISTENT_CONFIGURATION_FAIL = `${SCOPE}/UPDATE_URL_PERSISTENT_CONFIGURATION_FAIL`;

export const RESET_PERSISTENT_CONFIGURATION = `${SCOPE}/RESET_PERSISTENT_CONFIGURATION`;
export const SET_LOADING_FALSE = `${SCOPE}/SET_LOADING_FALSE`;
export const SET_PERSISTENCE_KEY = `${SCOPE}/SET_PERSISTENCE_KEY`;
